
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const HebrewInfoPage = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-5xl" dir="rtl">
      <Helmet>
        <title>מידע חשוב | Lainasampo</title>
        <meta name="description" content="מידע חשוב על שירותי ההלוואות שלנו ותנאים משפטיים בעברית." />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-4xl font-bold text-primary mb-4">מידע חשוב</h1>
        <p className="text-lg text-gray-600">
          דף זה מכיל מידע חשוב על השירותים שלנו ומסמכים משפטיים בעברית.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">תנאי שימוש</h2>
          <p className="mb-6">
            תנאי השימוש שלנו מסבירים את התנאים לשימוש בשירותי השוואת ההלוואות שלנו,
            כולל הזכויות והחובות שלך.
          </p>
          <Link to="/he/terms">
            <Button variant="outline" className="w-full">צפה בתנאי השימוש</Button>
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">מדיניות פרטיות</h2>
          <p className="mb-6">
            מדיניות הפרטיות שלנו מפרטת כיצד אנו מטפלים במידע האישי שלך,
            כולל מה אנחנו אוספים וכיצד אנו משתמשים בו.
          </p>
          <Link to="/he/privacy">
            <Button variant="outline" className="w-full">צפה במדיניות הפרטיות</Button>
          </Link>
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mb-12">
        <h2 className="text-2xl font-bold mb-4">תמיכת לקוחות</h2>
        <p className="mb-4">
          אם יש לך שאלות לגבי השירותים שלנו או שאתה זקוק לעזרה,
          צוות התמיכה שלנו זמין לעזור לך.
        </p>
        <p className="mb-4">
          דוא"ל: <a href="mailto:info@lainasampo.fi" className="text-primary hover:underline">info@lainasampo.fi</a>
        </p>
        <div className="flex flex-wrap gap-4 mt-6">
          <Link to="/hebrew">
            <Button variant="secondary">חזרה לדף הבית בעברית</Button>
          </Link>
          <Link to="/hebrew/apply">
            <Button>הגש בקשה להלוואה</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HebrewInfoPage;
